export default __webpack_public_path__ + "static/media/thatch.f3fb2b5f.jpg";